var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/cohen.onf.ca/node_modules/has/src/index.js
// module id = 374
// module chunks = 0